import React, {Component} from 'react';
import './VerifyCodeComponent.less';
import {FormInput} from '@homeaway/react-form-components';
import {TrackingContext} from '@homeaway/react-event-tracking';
import {ButtonLink, ButtonPrimary} from '@homeaway/react-buttons';
import {AlertInfo} from '@homeaway/react-alerts';
import {maskPhone, validateVerificationCode} from '../../util/phoneUtils';
import mfaClient from '../../util/mfaClient';

class VerifyCodeComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            verifyCode: '',
            showResendMsg: false,
            errorMsg: null
        };
    }

    handleVerifyCode = (e) => {
        if (validateVerificationCode(e.target.value)) {
            this.setState({verifyCode: e.target.value, errorMsg: ''});
        }
    };

    handleBackClick = () => {
        const {updatePage} = this.props;
        if (this.props.phoneList.length < 2) {
            updatePage('chooseContactType');
        } else {
            updatePage('choosePhone');
        }
    };

    handleResendMsg = () => {
        this.sendChallenge(this.props.contactType);
    };

    challengeDifferentContactType = () => {
        let alternateContactType = this.props.contactType === 'CALL' ? 'SMS' : 'CALL';
        this.sendChallenge(alternateContactType);
    };

    sendChallenge = (contactType) => {
        const publicUuid = this.props.publicUuid;
        this.setState({showResendMsg: false});
        mfaClient.challenge(this.props.challengeTicket, contactType, this.props.phoneNumber)
            .then(() => {
                setTimeout(() => {
                    this.setState({showResendMsg: true});
                }, 2000);
                this.context.trigger('mfa.challenge.attempt', {publicuuid: publicUuid, mfatype: 'challenge_2fa', mfamethod: contactType.toLowerCase()});
            }).catch(() => {
                this.props.handleError(this.props.lingua.read('error.generic'), '');
                this.context.trigger('mfa.challenge.failure', {publicuuid: publicUuid, mfatype: 'challenge_2fa', mfamethod: contactType.toLowerCase(), failurereason: 'service-failure'});
            });
    };

    verifyUserProvidedCode = () => {
        const publicUuid = this.props.publicUuid;
        const contactType = this.props.contactType;
        mfaClient.verify(this.props.challengeTicket, this.state.verifyCode)
            .then(() => {
                this.context.trigger('mfa.challenge.success', {publicuuid: publicUuid, mfatype: 'challenge_2fa', mfamethod: contactType.toLowerCase()});
                this.props.onClose();
            })
            .catch((error) => {
                if (error.status === 403) {
                    this.context.trigger('mfa.challenge.failure', {publicuuid: publicUuid, mfatype: 'challenge_2fa', mfamethod: contactType.toLowerCase(), failurereason: 'wrong-verify-code'});
                    this.setState({errorMsg: this.props.lingua.read('lex.owner.verify.error.code')});
                } else {
                    this.props.handleError(this.props.lingua.read('error.generic'), '');
                    this.context.trigger('mfa.challenge.failure', {publicuuid: publicUuid, mfatype: 'challenge_2fa', mfamethod: contactType.toLowerCase(), failurereason: 'service-failure'});
                }
            });
    };

    render() {
        let verifyInput = this.state.verifyCode && this.state.verifyCode.length === 6 ? false : true;
        let selectedPhone = {'phoneNumber': maskPhone(this.props.phoneNumber.phone)};
        let changeContactType = this.props.contactType === 'CALL' ? this.props.lingua.read('lex.owner.verify.texttype') : this.props.lingua.read('lex.owner.verify.calltype');
        return (
            <>
                <div className="VerifyForm">
                    <div className="title">
                        <p>{this.props.lingua.read('lex.owner.verify.subtitle')}</p>
                    </div>
                    <div className="message">
                        <p dangerouslySetInnerHTML={{__html: this.props.lingua.read('lex.owner.verify.message', selectedPhone)}} />
                    </div>
                    <FormInput
                        id="verifyCode"
                        name="verifyCode"
                        label={this.props.lingua.read('lex.owner.verify.prompt')}
                        value={this.state.verifyCode}
                        onChange={this.handleVerifyCode}
                        type="text"
                        errorMsg={this.state.errorMsg}
                        maxLength="6"
                        autoFocus
                    />
                    <div className="Resend">
                        <div>
                            <p>{this.props.lingua.read('lex.owner.verify.sublabel')}</p>
                            <ButtonLink id="resendCode" className="Link Code" label={this.props.lingua.read('lex.owner.verify.resend')} onClick={this.handleResendMsg}/>
                        </div>
                        { this.state.showResendMsg && (
                            <AlertInfo
                                msg={this.props.lingua.read('lex.owner.verify.resend.info')}
                                dismissible
                            />)
                        }
                        <ButtonLink id="changeContactType" className="Link Change" label={changeContactType} onClick={this.challengeDifferentContactType}/>
                    </div>
                    <div className="radiosnext">
                        <ButtonLink id="back" name="back" className="Link" label={this.props.lingua.read('lex.owner.button.back')} onClick={this.handleBackClick} />
                        <ButtonPrimary className="Confirm" id="confirm" name="confirm" type="button" label={this.props.lingua.read('lex.owner.button.confirm')} disabled={verifyInput} onClick={this.verifyUserProvidedCode}/>
                    </div>
                </div>
            </>
        );
    }
}

VerifyCodeComponent.contextType = TrackingContext;
export default VerifyCodeComponent;
